import React, { useEffect, useState, useRef } from 'react';
import swal from 'sweetalert2';
import * as helper from '../components/global/helper';
import noData from '../assets/images/no-data.png';
import ReactTooltip from "react-tooltip";
import moment from 'moment';

const imgUrl = 'https://metromatrix.s3.ap-south-1.amazonaws.com/Public/MetroMatrix/Content/';

import { getClientDetails, getClientList, postClient, postClientList } from './api/dashboardAPI';


const Dashboard = (props) => {

    const colors = ['#007bff', '#adb5bd', '#17a2b8', '#02b875'];

    const allowedDivisions = ['DO-ALIGARH','ASANSOL DO','AURANGABAD DO','BANGLORE DO-II','BARDHAMAN DO','BELGAUM DO','KMDO II','CHENNAI DO-I','CHENNAI DO-II','COIMBATORE DO','DEHRADUN DO','DHARWAD DO','ERNAKULAM DO','DO-FAIZABAD','DO-GORAKHPUR','DO-HALDWANI','INDORE DO','JABALPUR DO','JALPIGURI DO','JORHAT DO','KARIMNAGAR DO','KHARAGHPUR DO','KOLHAPUR DO','KOTTAYAM DO','KOZHI-KODI DO','MADURAI DO','MUMBAI DO-I','MYSORE DO','NASHIK DO','PUNE DO-II','RAICHUR DO','RAJKOT DO','SALEM DO','SATARA DO','SHIMOGA DO','SILCHAR DO','SURAT DO','TECH-TERM','THANE DO','THANJAVUR DO','THRISSUR DO','TIRUNELVELI DO','TRIVANADRUM DO','UDUPI DO','VADODARA DO','VELLORE DO','VISAKHAPATNAM DO','WARANGAL DO','DO-BAREILLY','AHMEDABAD DO','BANGLORE DO-I','KSDO','MUMBAI DO-III', 'VARANASI DO', 'LUCKNOW DO', 'KANPUR DO', 'PRYAGRAJ DO', 'ALLAHABAD DO', 'AYODHYA DO', 'RAIPUR DO', 'BILASPUR DO', 'SATNA DO', 'SHAHDOL DO', 'GWALIOR DO', 'BHOPAL DO', 'HYDERABAD DO','MACHILIPATNAM DO','SECUNDERABAD DO'];

    const [clients,             setClients]             = useState([]);
    const [clientList,          setClientList]          = useState([]);
    const [clientList1,         setClientList1]         = useState([]);
    const [comments,            setComments]            = useState([]);

    const [client,              setClient]              = useState({ID: 0});
    const [doctor,              setDoctor]              = useState(null);
    const [schedule,            setSchedule]            = useState(null);
    const [validated,           setValidated]           = useState(false);

    const [video,               setVideo]               = useState(null);
    const [videoURL,            setVideoURL]            = useState(null);
    const videoRef                                      = useRef(null);

    const [search,              setSearch]              = useState('');
    const [debouncedSearch,     setDebouncedSearch]     = useState('');
    const searchDebounceTimeout                         = useRef(null);
    

    useEffect(() => {
        const addModalElement = document.getElementById('addModal');
        const uploadModalElement = document.getElementById('uploadModal');
        const videoModalElement = document.getElementById('videoModal'); 
        const handleAddModalHide = () => resetData();
        const handleUploadModalHide = () => resetUploadData();
        const handleVideoModalHide = () => {
            if (videoRef.current) {
              videoRef.current.pause();
            }
        };
        addModalElement.addEventListener('hidden.bs.modal', handleAddModalHide);
        uploadModalElement.addEventListener('hidden.bs.modal', handleUploadModalHide);
        videoModalElement.addEventListener('hidden.bs.modal', handleVideoModalHide);

        return () => {
            addModalElement.removeEventListener('hidden.bs.modal', handleAddModalHide);
            uploadModalElement.removeEventListener('hidden.bs.modal', handleUploadModalHide);
            videoModalElement.removeEventListener('hidden.bs.modal', handleVideoModalHide);
        };    
        
    }, [])

    useEffect(() => {
        if (searchDebounceTimeout.current) {
            clearTimeout(searchDebounceTimeout.current);
        }

        searchDebounceTimeout.current = setTimeout(() => {
            setDebouncedSearch(search);
        }, 500);

        return () => {
            if (searchDebounceTimeout.current) {
                clearTimeout(searchDebounceTimeout.current);
            }
        };
    }, [search]);

    useEffect(() => {
       fetchClients({
            search: debouncedSearch,
            type: props.type,
            tpa: props.tpa,
            status: props.status
        });
    }, [debouncedSearch, props.type, props.status])

    useEffect(() => {
        if (video) {
            const url = URL.createObjectURL(video);
            setVideoURL(url);
        }else{
            URL.revokeObjectURL(videoURL);
            setVideoURL(null);
        }
    }, [video])

    const fetchClients = async (filters = {}) => {
        try {
            swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                didOpen: () => {
                    swal.showLoading();
                }
            });
             const { Clients } = await getClientList(filters);
             setClients(Clients);
             swal.close();
             return Clients;
        } catch (err) {
            swal.close();
            swal.fire({ icon: "error", titleText: "Error!", text: err.message });
            return;  
        }
    }

    const refreshClients = async () => {
        await fetchClients({
            search,
            tpa: props.tpa,
            status: props.status
        });
    }

    const fetchClientDetails = async (m) => {
        try {
            swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                didOpen: () => {
                    swal.showLoading();
                }
            });
            const { Client, Comments, Doctor, Schedule } = await getClientDetails(m.ID);
 
            const originalDivision = Client.Division || '';
            if (originalDivision && !allowedDivisions.includes(originalDivision)) {
                Client['M-Division'] = originalDivision;
                Client.Division = 'OTHERS';
            }
            
            setClient(Client);
            setComments(Comments);
            setDoctor(Doctor);
            setSchedule(Schedule);
            swal.close();
        } catch (err) {
            swal.close();
            swal.fire({ icon: "error", titleText: "Error!", text: err.message });
            return;  
        }
    }

    const postClientData = async(e)=> {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {     
            e.stopPropagation();
            setValidated(true);
        }else{
            try {              
                if (client.ID < 0) {
                    document.querySelector('#addModal .btn-close').click();
                    document.querySelector('#btnUpload').click();
                }else{
                    swal.fire({
                        titleText           : 'Loading',
                        text                : 'Please Wait...',
                        showConfirmButton   : false,
                        allowOutsideClick   : false,
                        didOpen: () => {
                            swal.showLoading();
                        }
                    });
    
                    await postClient({
                        ID          : client.ID ?? 0,
                        ProposalNo  : client.ProposalNo,
                        Type        : client.Type || 'NB',
                        Name        : client.Name,
                        Age         : client.Age || null,
                        Email       : client.Email || '',
                        Contact1    : client.Contact1,
                        Contact2    : client.Contact2 || '',
                        TestType    : client.TestType || 'VMER',
                        Language    : client.Language || '',
                        City        : client.City || '',
                        State       : client.State || '',
                        Division    : client.Division == 'OTHERS' ? client['M-Division'] : client.Division,
                        BranchCode  : client.BranchCode,
                        SumAssured  : client.SumAssured || '',
                        Remark      : client.Remark || ''
    
                    });
                    await refreshClients();
                    document.querySelector('#addModal .btn-close').click();
    
                    swal.close();
    
                    if (client.ID) {
                        swal.fire({
                            icon: 'success',
                            title: '<small>Client updated successfully!</small>',
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    }else {
                        swal.fire({
                            icon: 'success',
                            title: '<small>Client added successfully!</small>',
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    }
                }
          
            } catch (err) {
                swal.close();
                swal.fire({
                    icon              : "error",
                    titleText         : "Error!",
                    text              : err.message
                  })
                return;  
            }       
        }    
    }

    const postClientListData = async()=> {
        try {
            swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                didOpen: () => {
                    swal.showLoading();
                }
            });

            await postClientList(clientList);
            await refreshClients();
            document.querySelector('#uploadModal .btn-close').click();

            swal.close();

            if (client.ID) {
                swal.fire({
                    icon: 'success',
                    title: '<small>Client updated successfully!</small>',
                    showConfirmButton: false,
                    timer: 1500,
                });
            }else {
                swal.fire({
                    icon: 'success',
                    title: '<small>Client added successfully!</small>',
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
      
        } catch (err) {
            swal.close();
            swal.fire({
                icon              : "error",
                titleText         : "Error!",
                text              : err.message
              })
            return;  
        }  
    }

    const handleData = (key, value)=>{
        setClient((d)=> { return {...d, [key] : value} });
    };

    const resetData = () => {
        setClient({ID: 0});
        setDoctor(null);
        setSchedule(null);
        setComments([]);
        setValidated(false);
    };

    const resetUploadData = () => {
        setClientList([]);
        setClientList1([]);
    };

    const getColorForUserId = (userId) => {
        const colorIndex = userId % colors.length;
        return colors[colorIndex];
    };


    const fileHandler = async (file) => {
        try {
            swal.fire({
                titleText           : 'Processing Excel',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                didOpen: () => {
                    swal.showLoading();
                }
            });

            const result = await readFile(file);
            const data = helper.extractExcel(result);

            const rows = parseCSV(data);
            if (rows.length < 2) {
                return showWarning('No data found');
            }

            const headings = rows[0].split(',');
            if (!validateHeadings(headings)) {
                return showWarning('Unknown file. Please upload the file in given format.');
            }

            const content = rows.slice(1);

            let cList = [];
            let cList1 = [];
            const testType = document.getElementById('ddlTestType').value;

            content.forEach((element) => {
                const value = element.split(',');

                const data = helper.validateExcel(value);

                if (data.message != 'Success') {
                    cList1.push({
                        ...data.client,
                        TestType: testType,
                        Message: data.message
                    })
                }else{
                    cList.push({...data.client, TestType: testType})
                }
            });

            const recordMap = new Map();

            clients.filter(f => f.TestType == testType).forEach(client => {
                const key = `${client.Contact1}-${client.ProposalNo}`;
                recordMap.set(key, true);
            });

            cList = cList.filter(client => {
                const key = `${client.Contact1}-${client.ProposalNo}`;         
                if (recordMap.has(key)) {
                    cList1.push({...client, Message: 'Duplicate record'});
                  return false;
                } else {
                  recordMap.set(key, true);
                  return true;
                }
            });

            setClientList(cList);
            setClientList1(cList1);

            swal.close();

        } catch (error) {
            swal.close();
            showError('Error reading file. Please try again.');
        }
    }

    const validateHeadings = (headings) => {
        const requiredHeadings = ['proposalno', 'type', 'clientname', 'age', 'contactno', 'contactno2', 'testdetails', 'city', 'state', 'email', 'language', 'division', 'branchcode', 'sumassured', 'remark'];
        return requiredHeadings.every((heading, index) => 
            headings[index]?.replace(/\s+/g, '').trim().toLowerCase() === heading
        );
    };

    const readFile = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsBinaryString(file);

            reader.onload = () => resolve(reader.result);
            reader.onerror = () => reject(reader.error);
        });
    };

    const parseCSV = (data) => {
        return data.split('\n').filter((row) => row.split(',').length > 1);
    };

    const showWarning = (message) => {
        return swal.fire({
            icon: 'warning',
            titleText: 'Warning!',
            text: message
        });
    };

    const showError = (message) => {
        return swal.fire({
            icon: 'error',
            titleText: 'Error!',
            text: message
        });
    };

    const resolveDuplicate = (index) => {
        const list = clientList1.filter(f => f.Message == 'Duplicate record');
        const recordToMove = list[index]

        swal.fire({
            title: "<small>Do you want to upload anyway?</small>",
            showCancelButton: true,
            confirmButtonText: "Upload",
          }).then((result) => {
            if (result.isConfirmed) {
              setClientList1(prevList => prevList.filter(client => client.ProposalNo !== recordToMove.ProposalNo));
              setClientList(prevList => [...prevList, recordToMove]);
              swal.fire({
                icon: 'success',
                title: '<small>Saved!</small>',
                showConfirmButton: false,
                timer: 1500,
            });
            } 
        });
    };

    const resolveAllDuplicate = () => {
        const list = clientList1.filter(f => f.Message == 'Duplicate record');
        swal.fire({
            title: "<small>Do you want to upload all anyway?</small>",
            showCancelButton: true,
            confirmButtonText: "Upload",
          }).then((result) => {
            if (result.isConfirmed) {
              setClientList1(prevList => prevList.filter(client => client.Message !== 'Duplicate record'));
              setClientList(prevList => [...prevList, ...list]);
              swal.fire({
                icon: 'success',
                title: '<small>Saved!</small>',
                showConfirmButton: false,
                timer: 1500,
            });
            } 
        });
    };

    const handleDownloadPDF = (e, clientId) => {
        e.stopPropagation();
        helper.downloadAndOpenPDFHandler(clientId);

        const modalElement = document.getElementById('viewModal');
        const closeButton = modalElement.querySelector('.btn-close');

        const closeModalAfterOpen = () => {
            closeButton.click();
            modalElement.removeEventListener('shown.bs.modal', closeModalAfterOpen);
        };

        modalElement.addEventListener('shown.bs.modal', closeModalAfterOpen);
    };

    const handleDownloadVideo = async (clientId) => {
        if (!video) {
            const videoBlob = await helper.downloadVideoHandler(clientId);
            setVideo(videoBlob);
        }
    };

    return ( 
        <>
            <div className="navbar navbar-expand-lg fixed-top margin-t58" style={{backgroundColor: '#fff', zIndex: '1'}}>
                <div className="container d-block padding-t10" style={{height: '60px'}}>
                    <div className='row mb-4'>
                        <div className='col-lg-4'>
                            <div className='input-group'>
                                <span className='input-group-text fs-16'><i className="bi bi-search"></i></span>
                                <input 
                                    onChange={({ target }) => setSearch(target.value)}
                                    value={ search || '' }
                                    className="form-control fs-16" 
                                    type="search" 
                                    placeholder="Search"
                                />
                            </div>
                        </div>
                        <div className='col-lg-4 d-none d-lg-block'>
                            <div className='input-group'>
                                <span className='input-group-text fs-16'>Test</span>
                                <select value={props.type} onChange={({ target }) => props.setType(target.value)} className="form-select fs-16">
                                    <option value={'All'}>All</option>
                                    <option value={'VMER'}>VMER</option>
                                    <option value={'JMER'}>JMER</option>
                                    <option value={'TMER'}>TMER</option>
                                </select>
                            </div>
                        </div>
                        <div className='col-lg-4 d-none d-lg-block'>
                            <div className='input-group'>
                                <span className='input-group-text fs-16'>Status</span>
                                <select value={props.status} onChange={({ target }) =>props.setStatus(target.value)} className="form-select fs-16">
                                    <option value={'All'}>All</option>
                                    <option value={'Pending'}>Pending</option>
                                    <option value={'Assigned'}>Assigned</option>
                                    <option value={'Scheduled'}>Scheduled</option>
                                    <option value={'QC Pending'}>QC Pending</option>
                                    <option value={'Success'}>Success</option>
                                </select>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>

            <div className='container margin-t150'>               
                <div className='row'>
                    {clients.length > 0 ? clients.map((m, i) => (
                        <div key={i} className='col-md-6'>
                            <div className={`card mb-4 mx-1`} data-bs-toggle="modal" data-bs-target="#viewModal" key={m.ID} onClick={() => fetchClientDetails(m)}>
                                <div className="card-body">
                                    <h6 className="card-title">{m.Name}</h6>
                                    <span className='card-text fs-16'>
                                        <span>{m.Age ? `Age: ${m.Age} | ` : ''}Contact: {m.Contact1}{m.Contact2 ? `, ${m.Contact2}` : ''}</span><br></br>
                                        <span>{m.City ? `City: ${m.City}` : ''}{m.State ? `${m.City ? ' | ' : ''}State: ${m.State}` : ''}</span><br></br>
                                        <span>{m.Language ? `Language: ${m.Language}` : ''}{m.SumAssured ? `${m.Language ? ' | ' : ''}Sum Assured: ${m.SumAssured}` : ''}</span><br></br>
                                        <span>Type: {m.Type}</span><br></br>
                                        <span>{m.Remark ? `Remark: ${m.Remark}` : ''}</span><br></br>
                                        <span><small><strong>Uploaded Date: {moment(client.CreatedDate).format('DD MMM hh:mm A')}</strong></small></span>
                                    </span><br></br>
                                    <span className={`badge rounded-pill bg-${m.Status == 'Success' ? 'success' : m.Status == 'QC Pending' ? 'info' : m.Status == 'Scheduled' ? 'primary' : m.Status == 'Assigned' ? 'secondary' : 'warning'} mt-3 me-2`}>{m.Status}</span> 
                                    {(m.Status == 'Success') && <button type="button" className="btn btn-outline-primary btn-sm" onClick={(e) => handleDownloadPDF(e, m.ID)}><i className="bi bi-filetype-pdf me-1"></i>View PDF</button>}                              
                                </div>
                                <div className="card-footer footer-white fs-16">
                                    <span>Division: {m.Division} | Branch Code: {m.BranchCode}</span>
                                </div>
                                <div className="card-footer fs-16">
                                    <span><span className={`badge bg-${m.TestType == 'VMER' ? 'primary' : 'info'} me-2`}>{m.TestType}</span> Proposal No: {m.ProposalNo}</span>
                                </div>
                            </div>
                        </div>
                    )) : (
                            <div className='col-12'>
                            <div className='text-center mt-5'>
                                <img src={noData} alt="image"  height="150"/>
                                <h5 className='mt-3'>No Clients!</h5>
                            </div>
                        </div>
                    )}                                                                 
                    
                </div>
            </div>

            <div id='viewModal' className="modal modal-lg fade" tabIndex="-1" aria-labelledby="modalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id="modalLabel">Details</h6>
                            <div className="d-flex align-items-center ms-auto">
                                {(client.Status != "QC Pending" && client.Status != "Success") && (
                                    <button type="button" data-bs-toggle="modal" data-bs-target="#addModal" className="btn btn-outline-primary btn-sm me-2">
                                        <i className="bi bi-pencil"></i>
                                    </button>
                                )}
                                <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={resetData} aria-label="Close">
                                    <span aria-hidden="true"></span>
                                </button>
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className={`card mb-4 d-none d-lg-block`}>
                                    <div className="card-body d-flex justify-content-between align-items-center">
                                        <div>
                                            <h6 className="card-title">{client.Name}</h6>
                                            <span className='card-text fs-16'>
                                                <span>{client.Age ? `Age: ${client.Age} | ` : ''}Contact: {client.Contact1}{client.Contact2 ? `, ${client.Contact2}` : ''}</span><br></br>
                                                <span>{client.City ? `City: ${client.City}` : ''}{client.State ? `${client.City ? ' | ' : ''}State: ${client.State}` : ''}</span><br></br>
                                                <span>{client.Language ? `Language: ${client.Language}` : ''}{client.SumAssured ? `${client.Language ? ' | ' : ''}Sum Assured: ${client.SumAssured}` : ''}</span><br></br>
                                                <span>Type: {client.Type}</span><br></br>
                                                <span>{client.Remark ? `Remark: ${client.Remark}` : ''}</span><br></br>
                                                <span><small><strong>Uploaded Date: {moment(client.CreatedDate).format('DD MMM hh:mm A')}</strong></small></span>
                                            </span>
                                        </div>
                                        <div>
                                            <span className={`badge rounded-pill bg-${client.Status == 'Success' ? 'success' : client.Status == 'QC Pending' ? 'info' : client.Status == 'Scheduled' ? 'primary' : client.Status == 'Assigned' ? 'secondary' : 'warning'} me-5`}>{client.Status}</span>
                                        </div>
                                    </div>
                                    <div className="card-footer d-flex justify-content-between align-items-center fs-16">
                                        <span><span className={`badge bg-${client.TestType == 'VMER' ? 'primary' : 'info'} me-2`}>{client.TestType}</span> Proposal No: {client.ProposalNo}</span>
                                        <span>Division: {client.Division} | Branch Code: {client.BranchCode}</span>
                                    </div>
                                </div>

                                <div className={`card mb-4 d-lg-none`}>
                                    <div className="card-body">
                                        <h6 className="card-title">{client.Name}</h6>
                                        <span className='card-text fs-16'>
                                            <span>{client.Age ? `Age: ${client.Age} | ` : ''}Contact: {client.Contact1}{client.Contact2 ? `, ${client.Contact2}` : ''}</span><br></br>
                                            <span>{client.City ? `City: ${client.City}` : ''}{client.State ? `${client.City ? ' | ' : ''}State: ${client.State}` : ''}</span><br></br>
                                            <span>{client.Language ? `Language: ${client.Language}` : ''}</span><br></br>
                                            <span>{client.SumAssured ? `Sum Assured: ${client.SumAssured}` : ''}</span><br></br>
                                            <span>Type: {client.Type}</span><br></br>
                                            <span>{client.Remark ? `Remark: ${client.Remark}` : ''}</span><br></br>
                                            <span><small><strong>Uploaded Date: {moment(client.CreatedDate).format('DD MMM hh:mm A')}</strong></small></span>
                                        </span><br></br>
                                        <span className={`badge rounded-pill bg-${client.Status == 'Success' ? 'success' : client.Status == 'QC Pending' ? 'info' : client.Status == 'Scheduled' ? 'primary' : client.Status == 'Assigned' ? 'secondary' : 'warning'} mt-3 me-2`}>{client.Status}</span>                               
                                    </div>
                                    <div className="card-footer footer-white fs-16">
                                        <span>Division: {client.Division}</span><br></br>
                                        <span>Branch Code: {client.BranchCode}</span>
                                    </div>
                                    <div className="card-footer fs-16">
                                        <span><span className={`badge bg-${client.TestType == 'VMER' ? 'primary' : 'info'} me-2`}>{client.TestType}</span> Proposal No: {client.ProposalNo}</span>
                                    </div>
                                </div>

                                {doctor && (
                                    <>
                                        <div 
                                            className="card border-light mb-4" 
                                            style={{backgroundColor: '#eff3f7'}}
                                        >
                                            <div className="card-body d-flex justify-content-between align-items-center ms-2">
                                                <div className='flex-shrink-0'>
                                                    {doctor.Photo && doctor.Photo != '' ?
                                                        <img src={`${imgUrl}${doctor.Photo}`} alt="image" className="rounded-circle me-2" width="40" height="40"/> :
                                                        <div className="initial-circle-2x me-2">
                                                            {doctor.Name[0]}
                                                        </div>
                                                    }  
                                                </div>
                                                <div className="ms-2 flex-grow-1" style={{ lineHeight: '1' }}>
                                                    <h6 className="card-title fs-14 mb-1">Dr. {doctor.Name}</h6>
                                                </div>
                                                <div className='d-none d-lg-block'>
                                                    <span className='fs-14 fw-semibold me-3' style={{color:'#767676'}}><i className="bi bi-clock-fill me-2" style={{color:'#4582ec'}}></i>{schedule ? (moment(schedule.Date).format('DD MMM') + ' ' + schedule.From + ' - ' + schedule.To) : 'Schedule Pending'}</span>
                                                </div>
                                            </div>
                                            <div className="card-footer d-lg-none" style={{backgroundColor: '#eff3f7'}}>
                                                <span className='fs-14 fw-semibold ms-3' style={{color:'#767676'}}><i className="bi bi-clock-fill me-2" style={{color:'#4582ec'}}></i>{schedule ? (moment(schedule.Date).format('DD MMM') + ' ' + schedule.From + ' - ' + schedule.To) : 'Schedule Pending'}</span>
                                            </div>
                                        </div>

                                        {(client.Status == 'Success') && (
                                            <div className='row mb-4 justify-content-center'>
                                                <div className='col-6 mb-3'>
                                                    <button type="button" className="btn btn-outline-primary w-100" onClick={() => helper.downloadAndOpenPDFHandler(client.ID)}><i className="bi bi-filetype-pdf me-2"></i>View PDF</button>
                                                </div>
                                                {/* <div className='col-6 mb-3'>
                                                    <button type="button" className="btn btn-outline-info w-100" data-bs-toggle="modal" data-bs-target="#videoModal" onClick={() => handleDownloadVideo(client.ID)}><i className="bi bi-play-circle me-2"></i>Play Video</button>
                                                </div> */}
                                            </div>
                                        )}
                                    </>
                                )}

                                {comments.length > 0 && comments.map((m, i) => (
                                    <div key={m.ID} className="toast show mb-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                                        <div className="toast-header">
                                            {m.Photo && m.Photo != '' ?
                                                <img src={`${imgUrl}${m.Photo}`} alt="image" className="rounded-circle me-2" width="28" height="28"/> :
                                                <div className="initial-circle me-2" style={{ backgroundColor: getColorForUserId(m.UserType == 'Doctor' ? m.UserID + 1 : m.UserID) }}>
                                                    {m.UserName[0]}
                                                </div>
                                            }
                                            <strong className="me-auto">{m.UserName} {m.UserType == 'Doctor' && <i className="fi fi-rr-stethoscope text-primary ms-1"></i>}</strong>                
                                            <small className='fw-semibold'>{moment(m.CreatedDate).format("DD MMM hh:mm A")}</small>
                                        </div>
                                        <div className="toast-body">
                                            {m.Comment}
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={resetData}>Close</button>
                            {/* <button type="button" className="btn btn-success"><i className="bi bi-whatsapp me-2"></i>Whatsapp</button>
                            <button type="button" className="btn btn-info"><i className="bi bi-envelope me-2"></i>Email</button> */}
                        </div>
                    </div>
                </div>
            </div>

            <div id='addModal' className="modal modal-lg fade" tabIndex="-1" aria-labelledby="modalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id="modalLabel">{(!client.ID || client.ID == 0) ? 'Add' : 'Update'} Client</h6>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <form id='clientForm' className={`row mt-3 needs-validation ${validated ? "was-validated" : ""}`} noValidate onSubmit={postClientData}>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('ProposalNo', target.value)}
                                                value={ client.ProposalNo || '' }
                                                id="txtProposalNo" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='proposalNo' 
                                                required
                                            />
                                            <label htmlFor="txtProposalNo">Proposal No</label>
                                            <div className="invalid-feedback">Please enter proposal no.</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <select value={client.Type || ''} onChange={({ target }) => handleData('Type', helper.type(target.value))} className="form-select" id="ddlType">
                                                <option value={'NB'}>NB</option>
                                                <option value={'Revival'}>Revival</option>
                                                <option value={'PWB'}>PWB</option>
                                                <option value={'Outstation'}>Outstation</option>
                                            </select>
                                            <label htmlFor="ddlType">Type</label>
                                        </div>
                                    </div>
                                    <div className='col-md-12 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('Name', helper.camelCase(target.value))}
                                                value={ client.Name || '' }
                                                id="txtClientName" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='clientName' 
                                                required
                                            />
                                            <label htmlFor="txtClientName">Client Name</label>
                                            <div className="invalid-feedback">Please enter client name.</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('Contact1', helper.contact(target.value))}
                                                value={ client.Contact1 || '' }
                                                id="txtContactNo" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='contactNo' 
                                                required
                                            />
                                            <label htmlFor="txtContactNo">Contact No</label>
                                            <div className="invalid-feedback">Please enter contact no.</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('Contact2', helper.contact(target.value))}
                                                value={ client.Contact2 || '' }
                                                id="txtContactNo2" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='contactNo2' 
                                            />
                                            <label htmlFor="txtContactNo2">Contact No 2</label>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('Age', target.value)}
                                                value={ client.Age || '' }
                                                id="txtAge" 
                                                type="number" 
                                                className="form-control" 
                                                placeholder='age' 
                                            />
                                            <label htmlFor="txtAge">Age</label>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <select value={client.TestType || ''} onChange={({ target }) => handleData('TestType', target.value)} className="form-select" id="ddlTestDetails">
                                                <option value={'VMER'}>VMER</option>
                                                <option value={'JMER'}>JMER</option>
                                                <option value={'TMER'}>TMER</option>
                                            </select>
                                            <label htmlFor="ddlTestDetails">Test Details</label>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input
                                                onChange={({ target }) => handleData('City', helper.camelCase(target.value))}
                                                value={ client.City || '' }
                                                id="txtCity" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='city' 
                                            />
                                            <label htmlFor="txtCity">City</label>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('State', helper.camelCase(target.value))}
                                                value={ client.State || '' }
                                                id="txtState" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='state' 
                                            />
                                            <label htmlFor="txtState">State</label>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('Email', helper.email(target.value))}
                                                value={ client.Email || '' }
                                                id="txtEmail" 
                                                type="email" 
                                                className="form-control" 
                                                placeholder='email' 
                                            />
                                            <label htmlFor="txtEmail">Email</label>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('Language', helper.camelCase(target.value))}
                                                value={ client.Language || '' }
                                                id="txtLanguage" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='language' 
                                            />
                                            <label htmlFor="txtLanguage">Language</label>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <select value={client.Division || ''} onChange={({ target }) => handleData('Division', target.value)} className="form-select" id="ddlDivision">
                                                <option value={'DO-ALIGARH'}>DO-ALIGARH</option>
                                                <option value={'ASANSOL DO'}>ASANSOL DO</option>
                                                <option value={'AURANGABAD DO'}>AURANGABAD DO</option>
                                                <option value={'BANGLORE DO-II'}>BANGLORE DO-II</option>
                                                <option value={'BARDHAMAN DO'}>BARDHAMAN DO</option>
                                                <option value={'BELGAUM DO'}>BELGAUM DO</option>
                                                <option value={'KMDO II'}>KMDO II</option>
                                                <option value={'CHENNAI DO-I'}>CHENNAI DO-I</option>
                                                <option value={'CHENNAI DO-II'}>CHENNAI DO-II</option>
                                                <option value={'COIMBATORE DO'}>COIMBATORE DO</option>
                                                <option value={'DEHRADUN DO'}>DEHRADUN DO</option>
                                                <option value={'DHARWAD DO'}>DHARWAD DO</option>
                                                <option value={'ERNAKULAM DO'}>ERNAKULAM DO</option>
                                                <option value={'DO-FAIZABAD'}>DO-FAIZABAD</option>
                                                <option value={'DO-GORAKHPUR'}>DO-GORAKHPUR</option>
                                                <option value={'DO-HALDWANI'}>DO-HALDWANI</option>
                                                <option value={'INDORE DO'}>INDORE DO</option>
                                                <option value={'JABALPUR DO'}>JABALPUR DO</option>
                                                <option value={'JALPIGURI DO'}>JALPIGURI DO</option>
                                                <option value={'JORHAT DO'}>JORHAT DO</option>
                                                <option value={'KARIMNAGAR DO'}>KARIMNAGAR DO</option>
                                                <option value={'KHARAGHPUR DO'}>KHARAGHPUR DO</option>
                                                <option value={'KOLHAPUR DO'}>KOLHAPUR DO</option>
                                                <option value={'KOTTAYAM DO'}>KOTTAYAM DO</option>
                                                <option value={'KOZHI-KODI DO'}>KOZHI-KODI DO</option>
                                                <option value={'MADURAI DO'}>MADURAI DO</option>
                                                <option value={'MUMBAI DO-I'}>MUMBAI DO-I</option>
                                                <option value={'MYSORE DO'}>MYSORE DO</option>
                                                <option value={'NASHIK DO'}>NASHIK DO</option>
                                                <option value={'PUNE DO-II'}>PUNE DO-II</option>
                                                <option value={'RAICHUR DO'}>RAICHUR DO</option>
                                                <option value={'RAJKOT DO'}>RAJKOT DO</option>
                                                <option value={'SALEM DO'}>SALEM DO</option>
                                                <option value={'SATARA DO'}>SATARA DO</option>
                                                <option value={'SHIMOGA DO'}>SHIMOGA DO</option>
                                                <option value={'SILCHAR DO'}>SILCHAR DO</option>
                                                <option value={'SURAT DO'}>SURAT DO</option>
                                                <option value={'TECH-TERM'}>TECH-TERM</option>
                                                <option value={'THANE DO'}>THANE DO</option>
                                                <option value={'THANJAVUR DO'}>THANJAVUR DO</option>
                                                <option value={'THRISSUR DO'}>THRISSUR DO</option>
                                                <option value={'TIRUNELVELI DO'}>TIRUNELVELI DO</option>
                                                <option value={'TRIVANADRUM DO'}>TRIVANADRUM DO</option>
                                                <option value={'UDUPI DO'}>UDUPI DO</option>
                                                <option value={'VADODARA DO'}>VADODARA DO</option>
                                                <option value={'VELLORE DO'}>VELLORE DO</option>
                                                <option value={'VISAKHAPATNAM DO'}>VISAKHAPATNAM DO</option>
                                                <option value={'WARANGAL DO'}>WARANGAL DO</option>
                                                <option value={'DO-BAREILLY'}>DO-BAREILLY</option>
                                                <option value={'AHMEDABAD DO'}>AHMEDABAD DO</option>
                                                <option value={'BANGLORE DO-I'}>BANGLORE DO-I</option>
                                                <option value={'KSDO'}>KSDO</option>
                                                <option value={'MUMBAI DO-III'}>MUMBAI DO-III</option>
                                                 <option value={'VARANASI DO'}>VARANASI DO</option>
                                                <option value={'LUCKNOW DO'}>LUCKNOW DO</option>
                                                <option value={'KANPUR DO'}>KANPUR DO</option>
                                                <option value={'PRYAGRAJ DO'}>PRYAGRAJ DO</option>
                                                <option value={'ALLAHABAD DO'}>ALLAHABAD DO</option>
                                                <option value={'AYODHYA DO'}>AYODHYA DO</option>
                                                <option value={'RAIPUR DO'}>RAIPUR DO</option>
                                                <option value={'BILASPUR DO'}>BILASPUR DO</option>
                                                <option value={'SATNA DO'}>SATNA DO</option>
                                                <option value={'SHAHDOL DO'}>SHAHDOL DO</option>
                                                <option value={'GWALIOR DO'}>GWALIOR DO</option>
                                                <option value={'BHOPAL DO'}>BHOPAL DO</option>
                                                <option value={'HYDERABAD DO'}>HYDERABAD DO</option>
                                                <option value={'MACHILIPATNAM DO'}>MACHILIPATNAM DO</option>
                                                <option value={'SECUNDERABAD DO'}>SECUNDERABAD DO</option>
                                                <option value={'OTHERS'}>OTHERS</option>
                                            </select>
                                            <label htmlFor="ddlDivision">Division</label>
                                        </div>
                                    </div>
                                    {client.Division == 'OTHERS' && (
                                        <div className='col-md-6 mb-3'>
                                            <div className="form-floating">
                                                <input 
                                                    onChange={({ target }) => handleData('M-Division', helper.camelCase(target.value))}
                                                    value={ client['M-Division'] || '' }
                                                    id="txtDivision" 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder='division'
                                                    required
                                                />
                                                <label htmlFor="txtDivision">Enter Division</label>
                                                <div className="invalid-feedback">Please enter division.</div>
                                            </div>
                                        </div>
                                    )}
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('BranchCode', target.value)}
                                                value={ client.BranchCode || '' }
                                                id="txtBranchCode" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='branchCode'
                                                required
                                            />
                                            <label htmlFor="txtBranchCode">Branch Code</label>
                                            <div className="invalid-feedback">Please enter branch code.</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('SumAssured', target.value)}
                                                value={ client.SumAssured || '' }
                                                id="txtSumAssured" 
                                                type="number" 
                                                className="form-control" 
                                                placeholder='sumAssured'
                                            />
                                            <label htmlFor="txtSumAssured">Sum Assured</label>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('Remark', target.value)}
                                                value={ client.Remark || '' }
                                                id="txtRemark" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='remark'
                                            />
                                            <label htmlFor="txtRemark">Remark</label>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="submit" form='clientForm' className="btn btn-primary">Save</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id='uploadModal' className="modal modal-xl fade" tabIndex="-1" aria-labelledby="modalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id="modalLabel">Upload New Clients</h6>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                {clientList.length > 0 || clientList1.length > 0 ? (
                                    <div>
                                        {clientList1.filter(f => f.Message != 'Duplicate record').length > 0 && (
                                            <table className="table table-bordered mt-3">
                                                <thead>
                                                    <tr className='table-active'>
                                                        <th colSpan={15} className="text-center align-middle">Incorrect Records</th>
                                                    </tr>
                                                    <tr className='table-active'>
                                                        <th className="text-center align-middle">Status</th>
                                                        <th className="text-center align-middle">Proposal No</th>
                                                        <th className="text-center align-middle">Type</th>
                                                        <th className="text-center align-middle">Client Name</th>
                                                        <th className="text-center align-middle">Age</th>
                                                        <th className="text-center align-middle">Contact No</th>
                                                        <th className="text-center align-middle">Contact No 2</th>
                                                        <th className="text-center align-middle">Test Details</th>
                                                        <th className="text-center align-middle">City</th>
                                                        <th className="text-center align-middle">State</th>
                                                        <th className="text-center align-middle">Email</th>
                                                        <th className="text-center align-middle">Language</th>
                                                        <th className="text-center align-middle">Division</th>
                                                        <th className="text-center align-middle">Branch Code</th>
                                                        <th className="text-center align-middle">Sum Assured</th>
                                                        <th className="text-center align-middle">Remark</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {clientList1.filter(f => f.Message != 'Duplicate record').map((m, i) => (
                                                        <tr key={i}>
                                                            <td className="text-center align-middle">
                                                                <i 
                                                                    className="bi bi-exclamation-circle text-warning" 
                                                                    data-tip="Tooltip"
                                                                    data-for={`tooltip-status-${i}`}>
                                                                </i>
                                                                <ReactTooltip id={`tooltip-status-${i}`}  place="right" effect="solid">
                                                                    {m.Message}
                                                                </ReactTooltip>
                                                            </td>
                                                            <td className="text-center align-middle">{m.ProposalNo}</td>
                                                            <td className="text-center align-middle">{m.Type}</td>
                                                            <td className="align-middle">{m.Name}</td>
                                                            <td className="text-center align-middle">{m.Age}</td>
                                                            <td className="text-center align-middle">{m.Contact1}</td>
                                                            <td className="text-center align-middle">{m.Contact2}</td>
                                                            <td className="text-center align-middle">{m.TestType}</td>
                                                            <td className="text-center align-middle">{m.City}</td>
                                                            <td className="text-center align-middle">{m.State}</td>
                                                            <td className="text-center align-middle">{m.Email}</td>
                                                            <td className="text-center align-middle">{m.Language}</td>
                                                            <td className="text-center align-middle">{m.Division}</td>
                                                            <td className="text-center align-middle">{m.BranchCode}</td>
                                                            <td className="text-center align-middle">{m.SumAssured}</td>
                                                            <td className="align-middle">{m.Remark}</td>
                                                        </tr>
                                                    ))}

                                                </tbody>
                                            </table>
                                        )}

                                        {clientList1.filter(f => f.Message == 'Duplicate record').length > 0 && (
                                            <>
                                                <table className="table table-bordered mt-4">
                                                    <thead>
                                                        <tr className='table-active'>
                                                            <th colSpan={16} className="text-center align-middle padding-tb10">
                                                                <div className="d-flex justify-content-center align-items-center position-relative">
                                                                    <div className="position-absolute start-0">
                                                                        <button onClick={() => resolveAllDuplicate()} data-tip="Tooltip" data-for='tooltip-action-all' type="button" className="btn btn-outline-primary btn-sm me-2">
                                                                            <i className="bi bi-upload me-1"></i> Upload All
                                                                        </button> 
                                                                        <ReactTooltip id='tooltip-action-all'  place="right" effect="solid">
                                                                            Upload all anyway
                                                                        </ReactTooltip>
                                                                    </div>
                                                                    <span>Duplicate Records</span>
                                                                </div>
                                                                
                                                               
                                                            </th>
                                                        </tr>
                                                        <tr className='table-active'>
                                                            <th className="text-center align-middle">Status</th>
                                                            <th className="text-center align-middle">Action</th>
                                                            <th className="text-center align-middle">Proposal No</th>
                                                            <th className="text-center align-middle">Client Name</th>
                                                            <th className="text-center align-middle">Age</th>
                                                            <th className="text-center align-middle">Contact No</th>
                                                            <th className="text-center align-middle">Contact No 2</th>
                                                            <th className="text-center align-middle">Test Details</th>
                                                            <th className="text-center align-middle">City</th>
                                                            <th className="text-center align-middle">State</th>
                                                            <th className="text-center align-middle">Email</th>
                                                            <th className="text-center align-middle">Language</th>
                                                            <th className="text-center align-middle">Division</th>
                                                            <th className="text-center align-middle">Branch Code</th>
                                                            <th className="text-center align-middle">Sum Assured</th>
                                                            <th className="text-center align-middle">Remark</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {clientList1.filter(f => f.Message == 'Duplicate record').map((m, i) => (
                                                            <tr key={i}>
                                                                <td className="text-center align-middle">
                                                                    <i 
                                                                        className="bi bi-exclamation-circle text-warning" 
                                                                        data-tip="Tooltip"
                                                                        data-for='tooltip-duplicate'>
                                                                    </i>
                                                                </td>
                                                                <td className="text-center align-middle">
                                                                    <button onClick={() => resolveDuplicate(i)} data-tip="Tooltip" data-for='tooltip-action' type="button" className="btn btn-outline-primary btn-sm me-2">
                                                                        <i className="bi bi-upload"></i>
                                                                    </button> 
                                                                </td>
                                                                <td className="text-center align-middle">{m.ProposalNo}</td>
                                                                <td className="align-middle">{m.Name}</td>
                                                                <td className="text-center align-middle">{m.Age}</td>
                                                                <td className="text-center align-middle">{m.Contact1}</td>
                                                                <td className="text-center align-middle">{m.Contact2}</td>
                                                                <td className="text-center align-middle">{m.TestType}</td>
                                                                <td className="text-center align-middle">{m.City}</td>
                                                                <td className="text-center align-middle">{m.State}</td>
                                                                <td className="text-center align-middle">{m.Email}</td>
                                                                <td className="text-center align-middle">{m.Language}</td>
                                                                <td className="text-center align-middle">{m.Division}</td>
                                                                <td className="text-center align-middle">{m.BranchCode}</td>
                                                                <td className="text-center align-middle">{m.SumAssured}</td>
                                                                <td className="align-middle">{m.Remark}</td>
                                                            </tr>
                                                        ))}  
                                                    </tbody>
                                                </table>
                                                <ReactTooltip id='tooltip-duplicate'  place="right" effect="solid">
                                                    Duplicate Record
                                                </ReactTooltip>
                                                <ReactTooltip id='tooltip-action'  place="right" effect="solid">
                                                    Upload anyway
                                                </ReactTooltip>
                                            </>
                                        )}

                                        {clientList.length > 0 && (
                                            <table className="table table-bordered mt-4">
                                                <thead>
                                                    <tr className='table-active'>
                                                        <th colSpan={15} className="text-center align-middle">Data to be uploaded</th>
                                                    </tr>
                                                    <tr className='table-active'>
                                                        <th className="text-center align-middle">Status</th>
                                                        <th className="text-center align-middle">Proposal No</th>
                                                        <th className="text-center align-middle">Client Name</th>
                                                        <th className="text-center align-middle">Age</th>
                                                        <th className="text-center align-middle">Contact No</th>
                                                        <th className="text-center align-middle">Contact No 2</th>
                                                        <th className="text-center align-middle">Test Details</th>
                                                        <th className="text-center align-middle">City</th>
                                                        <th className="text-center align-middle">State</th>
                                                        <th className="text-center align-middle">Email</th>
                                                        <th className="text-center align-middle">Language</th>
                                                        <th className="text-center align-middle">Division</th>
                                                        <th className="text-center align-middle">Branch Code</th>
                                                        <th className="text-center align-middle">Sum Assured</th>
                                                        <th className="text-center align-middle">Remark</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {clientList.map((m, i) => (
                                                        <tr key={i}>
                                                            <td className="text-center align-middle"><i className="bi bi-check-circle text-success"></i></td>
                                                            <td className="text-center align-middle">{m.ProposalNo}</td>
                                                            <td className="align-middle">{m.Name}</td>
                                                            <td className="text-center align-middle">{m.Age}</td>
                                                            <td className="text-center align-middle">{m.Contact1}</td>
                                                            <td className="text-center align-middle">{m.Contact2}</td>
                                                            <td className="text-center align-middle">{m.TestType}</td>
                                                            <td className="text-center align-middle">{m.City}</td>
                                                            <td className="text-center align-middle">{m.State}</td>
                                                            <td className="text-center align-middle">{m.Email}</td>
                                                            <td className="text-center align-middle">{m.Language}</td>
                                                            <td className="text-center align-middle">{m.Division}</td>
                                                            <td className="text-center align-middle">{m.BranchCode}</td>
                                                            <td className="text-center align-middle">{m.SumAssured}</td>
                                                            <td className="align-middle">{m.Remark}</td>
                                                        </tr>
                                                    ))}

                                                </tbody>
                                            </table>
                                        )}

                                    </div>
                                ) : (
                                    <form className='row my-3'>
                                        <div className='col-12 mb-3'>
                                            <div className='input-group'>
                                                <span className='input-group-text'>Test</span>
                                                <select id='ddlTestType' className="form-select fs-16">
                                                    <option value={'VMER'}>VMER</option>
                                                    <option value={'JMER'}>JMER</option>
                                                    <option value={'TMER'}>TMER</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className='col-12 mb-3'>
                                            <input 
                                                className="form-control" 
                                                type="file" 
                                                id="formFile"
                                                accept=".csv, .xlsx, .xls"
                                                onChange={({ target: { files } }) => fileHandler(files[0])}
                                            />
                                        </div>
                                        <div className='col-12 p-4 text-center'>
                                            <span>Please upload only <strong>Excel</strong> or <strong>CSV</strong> file <br></br>You can <a href="/file/clients.xlsx" download>download the file template</a> here</span>

                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="button" className="btn btn-primary" onClick={postClientListData}>Upload</button>
                        </div>
                    </div>
                </div>
            </div>

            <div
                id="videoModal"
                className="modal fade"
                tabIndex="-1"
                aria-labelledby="modalLabel"
                aria-hidden="true"
                data-bs-backdrop="static" 
                data-bs-keyboard="false"
            >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    {videoURL && (
                        <div className="modal-content" style={{backgroundColor: '#000'}}>
                            <button style={{zIndex: '1'}} type="button" className="position-absolute top-0 end-0 m-3 bg-transparent border-0 text-white" data-bs-toggle="modal" data-bs-target="#viewModal" aria-label="Close">
                                <i className="bi bi-x-lg"></i>
                            </button>
                            <div className="modal-body p-0"> 
                                <video controls autoPlay style={{ width: "100%", height: "100%", borderRadius: '8px' }} src={videoURL} ref={videoRef} />
                            </div>
                        </div>
                    )}
                </div>
            </div>

        </>
    )

}

export default Dashboard;